import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Paper,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FieldGoalPlaySelector } from "./FieldGoalPlaySelector";
import { FieldGoalKickLog } from "./FieldGoalKickLog";
import { useLogger } from "../../../../contexts/LoggerContext";
import { PenaltyLog } from "../Components/PenaltyLog";
import { useDepthChart } from "../../../../contexts/DepthChartContext";
import { FGTwoPointLog } from "./FGTwoPointLog";

export const FieldGoalLogger = () => {
  const [expandedAccordion, setExpandedAccordion] = useState<string | false>(
    "play-selection"
  );
  const { clearSelections } = useLogger();
  const [kickType, setKickType] = useState<"PAT" | "FG">("PAT");
  const { fieldGoalPlayers } = useDepthChart();

  const handleAccordionChange =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpandedAccordion(isExpanded ? panel : false);
    };

  useEffect(() => {
    if (clearSelections) {
      setExpandedAccordion("play-selection");
    }
  }, [clearSelections]);

  return (
    <Paper elevation={3} sx={{ p: 1, margin: "0 auto" }}>
      <Box>
        {/* Play Selection */}
        <Accordion
          expanded={expandedAccordion === "play-selection"}
          onChange={handleAccordionChange("play-selection")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="play-selection-content"
            id="play-selection-header"
          >
            <Typography>Play Selection</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <FieldGoalPlaySelector
              kickType={kickType}
              setKickType={setKickType}
            />
          </AccordionDetails>
        </Accordion>

        {/* Kick Log */}
        <Accordion
          expanded={expandedAccordion === "run-log"}
          onChange={handleAccordionChange("run-log")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="run-log-content"
            id="run-log-header"
          >
            <Typography>Kick Log</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <FieldGoalKickLog kickType={kickType} setKickType={setKickType} />
          </AccordionDetails>
        </Accordion>

        {/* 2PT Log  */}
        <Accordion
          expanded={expandedAccordion === "2pt-log"}
          onChange={handleAccordionChange("2pt-log")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="2pt-log-content"
            id="2pt-log-header"
          >
            <Typography>2 PT Log</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <FGTwoPointLog kickType={kickType} />
          </AccordionDetails>
        </Accordion>

        {/* Penalty Log */}
        <Accordion
          expanded={expandedAccordion === "penalty-log"}
          onChange={handleAccordionChange("penalty-log")}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="penalty-log-content"
            id="penalty-log-header"
          >
            <Typography>Penalty Log</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <PenaltyLog players={fieldGoalPlayers} />
          </AccordionDetails>
        </Accordion>
      </Box>
    </Paper>
  );
};

export default FieldGoalLogger;
